import { formatCnpj, isValidCnpj } from '../../../../utils/cnpj/cnpj';
import { Field, FormGrid, FormWrapper, Title } from '../styled';

type EmpresaData = {
  cnpj: string;
  state_registration: string;
  company_name: string;
  company_phone: string;
  company_mail: string;
};

interface StepEmpresaProps {
  value: EmpresaData;
  onChange: (data: EmpresaData) => void;
}

export default function StepEmpresa({ value, onChange }: StepEmpresaProps) {
  const set = (k: keyof EmpresaData, v: string) =>
    onChange({ ...value, [k]: v });

  const formatTelefone = (value: string) => {
    return value
      .replace(/\D/g, '')
      .slice(0, 11)
      .replace(/^(\d{2})(\d)/g, '($1) $2')
      .replace(/(\d{5})(\d{1,4})$/, '$1-$2');
  };

  return (
    <FormWrapper>
      <Title>Informações da empresa</Title>

      <FormGrid>
        <Field>
          <label>CNPJ</label>
          <input
            type='text'
            placeholder='00.000.000/0000-00'
            value={value.cnpj}
            onChange={(e) => set('cnpj', formatCnpj(e.target.value))}
            autoCapitalize='characters'
          />
          {value.cnpj.length === 18 && !isValidCnpj(value.cnpj) && (
            <span style={{ color: 'red', fontSize: 12, marginTop: 4 }}>
              CNPJ inválido
            </span>
          )}
        </Field>

        <Field>
          <label>Inscrição estadual</label>
          <input
            placeholder='Informe a inscrição estadual'
            value={value.state_registration}
            onChange={(e) => set('state_registration', e.target.value)}
          />
        </Field>

        <Field style={{ gridColumn: '1 / span 2' }}>
          <label>Razão social</label>
          <input
            placeholder='Digite a razão social completa'
            value={value.company_name}
            onChange={(e) => set('company_name', e.target.value)}
          />
        </Field>

        <Field>
          <label>Telefone</label>
          <input
            type='text'
            placeholder='(00) 00000-0000'
            value={value.company_phone}
            onChange={(e) =>
              set('company_phone', formatTelefone(e.target.value))
            }
            inputMode='numeric'
          />
        </Field>

        <Field>
          <label>Email</label>
          <input
            type='email'
            placeholder='Informe o e-mail da empresa'
            value={value.company_mail}
            onChange={(e) => set('company_mail', e.target.value)}
            autoComplete='email'
          />
        </Field>
      </FormGrid>
    </FormWrapper>
  );
}
